angular.module('admin.services')

.factory('RecurlyTokenService', [function(){
  return {
    fetchToken: function(htmlFormElement){
      return new Promise((resolve, reject) => {
        recurly.token(htmlFormElement, (err, token) => {
          if(err)
            return reject(err);

          if(!token.id)
            return reject('Unable to get credit card authorization.');

          resolve(token.id);
        });
      });
    }
  }
}]);
